import React from 'react';

import TMSSubTemplesManagement from '../../components/tms-temple-management/tms-sub-temples-management';
import { useParams } from 'react-router-dom';
import { withRouter } from '../../utils/tms-with-router/tms-with-router';

const TMSSubTemplesManagementPage = () => {
  const params = useParams();

  return <TMSSubTemplesManagement templeId={params.templeId} />;
};

export default withRouter(TMSSubTemplesManagementPage);
